import Footer from "./Layout/Footer/Footer";
import Header from "./Layout/Header/Header";
import Stake from "./Pages/Stake/Stake";
import OnBoardProvider from "./context/OnBoardProvider";
import { getChain } from "./web3Utils/ChainUtils/chainList";
import { readSelectedChainId } from "./configs/chainIdConfigs";
import WalletContextProvider from "./context/WalletContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <OnBoardProvider chain={getChain(readSelectedChainId())}>
        <WalletContextProvider chain={getChain(readSelectedChainId())}>
          <Header />
          <Stake />
          <Footer />
        </WalletContextProvider>
      </OnBoardProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* Same as */}
      <ToastContainer />
    </div>
  );
}

export default App;
